import { render } from "./app-text-icon.vue?vue&type=template&id=2cb3cd22"
import script from "./app-text-icon.vue?vue&type=script&lang=js"
export * from "./app-text-icon.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/payje-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__